/** Single-tenant deployment: all rows use this tenant id. */
export const DEFAULT_TENANT_ID = '00000000-0000-0000-0000-000000000000';
